const r = {
  MOBILE: 640,
  TABLET: 768
}, T = (t, o) => {
  let e;
  return () => {
    clearTimeout(e), e = setTimeout(t, o);
  };
};
export {
  r as a,
  T as m
};
